// src/hooks/useReviewExistence.ts
import { useState, useEffect } from 'react';
import { useReviewStore } from '../stores/reviewStore';
import { useProfileStore } from '../stores/profileStore';

export const useReviewExistence = (quoteId: string, reviewedId: string) => {
  const { profile } = useProfileStore();
  const { doesReviewExists } = useReviewStore();
  const [reviewExists, setReviewExists] = useState(false);

  useEffect(() => {
    const checkExisting = async () => {
      if (profile) {
        const exists = await doesReviewExists(quoteId, reviewedId);
        setReviewExists(exists);
      }
    };
    checkExisting();
  }, [quoteId, reviewedId, profile, doesReviewExists]);

  return reviewExists;
};
